import Card from "components/card";
import BarChart from "components/charts/BarChart";
import { useState, useEffect } from "react";
import { fetchData } from "services/ApiFetching";

const WeeklyRevenue = () => {
  const [barChartData, setBarChartData] = useState([]);
  const [xAxisCategories, setXAxisCategories] = useState([]);

  useEffect(() => {
    const fetchChartData = async () => {
      try {
        const result = await fetchData("dashboard/getTenDayCount");

        if (result?.series && result?.categories) {
          setBarChartData(result.series);
          setXAxisCategories(result.categories);
        } else {
          console.warn("⚠️ No chart data received.");
        }
      } catch (err) {
        console.error("❌ Error fetching chart data", err);
      }
    };

    fetchChartData();
  }, []);

  const barChartOptions = {
    chart: {
      stacked: true,
      toolbar: { show: false },
    },
    tooltip: {
      style: {
        fontSize: "12px",
        backgroundColor: "#000000",
      },
      theme: 'dark',
    },
    xaxis: {
      categories: xAxisCategories,
      show: false,
      labels: {
        show: true,
        style: {
          colors: "#A3AED0",
          fontSize: "14px",
          fontWeight: "500",
        },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      show: false,
      labels: {
        show: false,
        style: {
          colors: "#A3AED0",
          fontSize: "14px",
          fontWeight: "500",
        },
      },
    },
    grid: {
      borderColor: "rgba(163, 174, 208, 0.3)",
      show: true,
      yaxis: { lines: { show: false } },
      xaxis: { lines: { show: false } },
    },
    fill: {
      type: "solid",
      colors: ["#4318FF", "#23905f", "#6AD2FF", "#FF0000"],
    },
    legend: { show: false },
    dataLabels: { enabled: false },
    plotOptions: {
      bar: {
        borderRadius: 10,
        columnWidth: "20px",
      },
    },
  };

  return (
    <Card extra="flex flex-col bg-white w-full rounded-3xl py-6 px-2 text-center">
      <div className="mb-auto flex items-center justify-between px-6">
        <h2 className="text-lg font-bold text-navy-700 dark:text-white">
          Daily Tickets
        </h2>
        <button className="px-3 rounded-lg bg-lightPrimary p-2 text-brand-500 hover:bg-gray-100 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20">
          Last 10 Days
        </button>
      </div>

      <div className="md:mt-16 lg:mt-0">
        <div className="h-[250px] w-full xl:h-[350px]">
          {barChartData.length > 0 ? (
            <BarChart
              chartData={barChartData}
              chartOptions={barChartOptions}
            />
          ) : (
            <p className="text-gray-400 dark:text-white">Loading chart...</p>
          )}
        </div>
      </div>
    </Card>
  );
};

export default WeeklyRevenue;
